import { createStyles } from '../../../../../../../styles/helpers'

export default createStyles({
  switchAdTypeBtn: {
    width: '100%',
    marginTop: 20,
    marginBottom: 10
  }
})
